import { ErrorDetail, SigningRequest, SigningRequestClient } from '@microsoft/esign.gateway.service.client';
import { Constants } from '../../../common/Constants';
import { ApprovalRequestType } from '../../../data/types.generated';
import { getEsignGatewayProvider } from '../../../utilities/EsignUtils';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { delay } from '../../../utilities/Utils';
import { fetchAndLog, getEsignGatewayConfiguration } from '../utils/Authentication/EsignAuthHelpers';

export const createEsignApproval = async (
    approvalRequestType: ApprovalRequestType,
    signingRequestFn: () => SigningRequest
): Promise<string> => {
    try {
        const signingRequest = signingRequestFn();
        const esignGatewayConfiguration = await getEsignGatewayConfiguration(approvalRequestType);
        const provider = getEsignGatewayProvider(approvalRequestType);
        const signingRequestClient = new SigningRequestClient(esignGatewayConfiguration, null, {
            fetch: fetchAndLog,
        });
        const signingRequestId = await signingRequestClient.createSigningRequest(provider, signingRequest);
        const signingRequestUrl = (await signingRequestClient.getSigningRequest(signingRequestId, provider)).url;
        await delay(Constants.screenReaderWaitTime);
        return signingRequestUrl;
    } catch (error: any) {
        getAppHost().getLogger().logTraceHttpException('CreateEsignApproval', error.message, error.status);

        let errorDetail: ErrorDetail | null;
        try {
            errorDetail = JSON.parse(error.response);
        } catch {
            errorDetail = null;
        }

        throw new Error(errorDetail?.innerError?.code?.toLowerCase());
    }
};
